import { Link, useLocation } from 'react-router-dom'

import AdminViewIcon from '@/assets/icons/admin-view.svg?react'
import MemberViewIcon from '@/assets/icons/member-view.svg?react'
import { Trans } from '@/components/Trans'
import { cn } from '@/utils/style'

export type ViewMode = 'member' | 'admin'

export function ViewSwitcher() {
  const location = useLocation()
  const isAdminView = location.pathname.includes('/team/space/admin')

  return (
    <div className="bg-neutral-50 p-1 rounded-xl flex gap-1">
      <Link
        to="/team/space/member"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          !isAdminView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <MemberViewIcon className="w-5 h-5" />
        <Trans i18nKey="common.viewSwitcher.memberView">Member View</Trans>
      </Link>
      <Link
        to="/team/space/admin"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          isAdminView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <AdminViewIcon className="w-5 h-5" />
        <Trans i18nKey="common.viewSwitcher.adminView">Admin View</Trans>
      </Link>
    </div>
  )
}
